import { render, staticRenderFns } from "./rewardBuildPackEdit.vue?vue&type=template&id=635edeb8&scoped=true&"
import script from "./rewardBuildPackEdit.vue?vue&type=script&lang=js&"
export * from "./rewardBuildPackEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "635edeb8",
  null
  
)

export default component.exports